mutation recreateSlotText($input: SlotRefInput!) {
  slot: recreateSlotText(input: $input) {
    id
    platform
    topicId
    topicName
    scheduledLocal {
      date
      time
    }
    hint
    generatedText
    textChoices
    textStatus
    generationError
    status
    savedContentId
  }
}
